// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Route transition loader — minimal loading bar */

.route-loading-fallback {
  display: flex;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    165deg,
    rgb(252 251 248) 0%,
    rgb(255 255 255) 42%,
    rgb(248 246 242) 100%
  );
}

.route-loading-inner {
  --route-loading-cycle: 3.2s;
  --route-loading-ease: cubic-bezier(0.4, 0, 0.2, 1);

  display: flex;
  align-items: center;
  justify-content: center;
}

/* Editorial rule with a soft sweep (wholesale line-sheet vibe) */
.route-loading-rule {
  position: relative;
  width: min(11.5rem, 72vw);
  height: 2px;
  border-radius: 1px;
  background: rgb(28 28 28 / 0.08);
  overflow: hidden;
}

.route-loading-rule-highlight {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 32%;
  border-radius: inherit;
  background: linear-gradient(
    90deg,
    transparent,
    rgb(28 28 28 / 0.07) 40%,
    rgb(28 28 28 / 0.14) 50%,
    rgb(28 28 28 / 0.07) 60%,
    transparent
  );
  animation: route-loading-rule-sweep var(--route-loading-cycle)
    var(--route-loading-ease) infinite;
}

@keyframes route-loading-rule-sweep {
  0% {
    transform: translateX(-100%);
    opacity: 0.85;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(300%);
    opacity: 0.85;
  }
}

@media (prefers-reduced-motion: reduce) {
  .route-loading-rule-highlight {
    animation: none;
    transform: translateX(31%);
    opacity: 0.85;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RouteLoadingFallback.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB;;;;;GAKC;AACH;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;;EAElD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB;;;;;;;GAOC;EACD;sCACoC;AACtC;;AAEA;EACE;IACE,4BAA4B;IAC5B,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,2BAA2B;IAC3B,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;IACf,0BAA0B;IAC1B,aAAa;EACf;AACF","sourcesContent":["/* Route transition loader — minimal loading bar */\n\n.route-loading-fallback {\n  display: flex;\n  width: 100%;\n  min-height: 100vh;\n  min-height: 100dvh;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    165deg,\n    rgb(252 251 248) 0%,\n    rgb(255 255 255) 42%,\n    rgb(248 246 242) 100%\n  );\n}\n\n.route-loading-inner {\n  --route-loading-cycle: 3.2s;\n  --route-loading-ease: cubic-bezier(0.4, 0, 0.2, 1);\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Editorial rule with a soft sweep (wholesale line-sheet vibe) */\n.route-loading-rule {\n  position: relative;\n  width: min(11.5rem, 72vw);\n  height: 2px;\n  border-radius: 1px;\n  background: rgb(28 28 28 / 0.08);\n  overflow: hidden;\n}\n\n.route-loading-rule-highlight {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 32%;\n  border-radius: inherit;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgb(28 28 28 / 0.07) 40%,\n    rgb(28 28 28 / 0.14) 50%,\n    rgb(28 28 28 / 0.07) 60%,\n    transparent\n  );\n  animation: route-loading-rule-sweep var(--route-loading-cycle)\n    var(--route-loading-ease) infinite;\n}\n\n@keyframes route-loading-rule-sweep {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0.85;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(300%);\n    opacity: 0.85;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .route-loading-rule-highlight {\n    animation: none;\n    transform: translateX(31%);\n    opacity: 0.85;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
